import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';

import commonStyles from '../../Common/commonStyles';
import defaultTextValue from '../../Common/defaultTextValue';

const styles = StyleSheet.create({
  detailsView: {
    display: 'flex',
    flexDirection: 'row',
    marginHorizontal: commonStyles.marginHorizontal,
    marginBottom: '4%',
  },
  columnTitle: {
    ...commonStyles.fontS,
    paddingBottom: 4,
    borderBottom: '1px solid #b8b8b8',
    marginBottom: 5,
  },
  detailsColumn: {
    width: '50%',
    marginRight: '5%',
  },
  detail: {
    marginLeft: 5,
    marginBottom: 5,
  },
  detailTitle: {
    ...commonStyles.fontXS,
  },
  detailDescription: {
    ...commonStyles.fontXS,
  },
});

export function Detail({ title, description, width }) {
  return (
    <View style={[styles.detail, { width, maxWidth: width }]}>
      <Text style={styles.detailTitle}>{defaultTextValue(title)}</Text>
      <Text style={styles.detailDescription}>{defaultTextValue(description)}</Text>
    </View>
  );
}

function Details({
  admins,
  brand,
  category,
  code,
  designers,
  patternMaker,
  season,
  // specificationMemberProduction,
  t,
  title,
}) {
  return (
    <View style={styles.detailsView}>
      <View style={styles.detailsColumn}>
        <Text style={styles.columnTitle}>{t('basic_informations')}</Text>
        <Detail title={t('common:name')} description={title} />
        <Detail title={t('category')} description={category} />
        <Detail title={t('brand')} description={brand} />
        <Detail title={t('season')} description={season} />
        <Detail title={t('item_code')} description={code} />
      </View>
      <View style={styles.detailsColumn}>
        <Text style={styles.columnTitle}>{t('project_team')}</Text>
        <Detail title={t('specification:specification_member_ADMIN')} description={admins} />
        <Detail title={t('specification:specification_member_DESIGNER')} description={designers} />
        <Detail
          title={t('specification:specification_member_PATTERNER')}
          description={patternMaker}
        />
        {/* <Detail
          title={t('specification:specification_member_PRODUCTION')}
          description={specificationMemberProduction}
        /> */}
      </View>
    </View>
  );
}

export default withTranslation('specification')(Details);
